module.exports = __webpack_public_path__ + "static/media/chainsecurity.2dda438a.svg";